import React from 'react';

//style
import './style.scss';

export default function Input({
  inputType,
  inputValue,
  placeholder,
  onChange,
  children,
  required,
}) {
  return (
    <>
      <div className="forminput">
        <div className="icon">{children}</div>
        <input
          type={inputType}
          value={inputValue}
          placeholder={placeholder}
          onChange={onChange}
          required={required}
        />
      </div>
    </>
  );
}
